import { Modal2 } from 'components/Modal'
import SubmitButton from 'components/SubmitButton'
import { Form, Formik } from 'formik'
import { ToastContent, useToast } from './Toast'

interface SubmitHelpers {
  addToast: (content: ToastContent) => void
}

interface ActionModalProps<T> {
  header: React.ReactNode
  formikInitialValues: T
  children: React.ReactNode
  onSubmit: (values: T, helpers: SubmitHelpers) => void | Promise<void>
  onRequestClose: () => void
  submitText: string
}

const ActionModal = <T,>({
  header,
  onSubmit,
  formikInitialValues,
  children,
  onRequestClose,
  submitText,
}: ActionModalProps<T>) => {
  const { addToast } = useToast()

  return (
    <Modal2 isOpen onRequestClose={onRequestClose} header={header}>
      <Formik
        initialValues={formikInitialValues}
        onSubmit={async (values, { setStatus }) => {
          try {
            await onSubmit(values, { addToast })

            onRequestClose()
          } catch (err) {
            setStatus({ error: err.message })
          }
        }}
      >
        {({ isSubmitting, status }) => (
          <Form>
            {children}

            <div className="buttons is-right mt-5">
              <SubmitButton className="is-primary" submitting={isSubmitting} disabled={isSubmitting}>
                {submitText}
              </SubmitButton>
            </div>

            {status?.error && (
              <article className="message is-danger">
                <div className="message-body">Failed: {status.error}</div>
              </article>
            )}
          </Form>
        )}
      </Formik>
    </Modal2>
  )
}

export default ActionModal
